import $ from 'jquery';
import listService from 'ListService';
import constants from 'Constants.js';
import Immutable from 'immutable';
import util from 'util/Util.js';
import TextUtil from 'util/TextUtil.js';
import BasePropertyView from 'BasePropertyView.js';

import formatTemplate from 'properties/table/column-main-date-value.ejs';
import dateUtil from 'shared/DateUtil.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';


class MainDateValueView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change input[type=radio]' : 'setDateValue',
            'change input[type=date]' : 'setSpecificDate',
            'change #dateFormat, input[name="minYear"], input[name="maxYear"]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'keydown input.numeric, input[type=number]': 'validatePositiveNumeric'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }

        if (!this.columnModel.get('minYear')) {
            this.columnModel.set('minYear', '1900', {silent:true});
        }
        if (!this.columnModel.get('maxYear')) {
            this.columnModel.set('maxYear', '2100', {silent:true});
        }

        if (util.isTrue( this.columnModel.get('showEmpty')) ) {
            this.columnModel.set('dateValueType', 'Empty', {silent: true});
        }
        if (util.isTrue( this.columnModel.get('showNow')) ) {
            this.columnModel.set('dateValueType', 'Now', {silent: true});
        }

        if (!this.columnModel.get('dateValueObj')) {
            this.columnModel.set('dateValueObj', this.columnModel.get('specific'), {silent:true});
        }

        if (this.columnModel.get('specific')) {
            const d = this.getFormattedDate(this.columnModel.get('dateValueObj'));
            if (d) {
                this.columnModel.set('specific', d, {silent: true});
                this.columnModel.set('specificDisplay', dateUtil.getFormattedDate(this.columnModel.get('dateValueObj'), constants.PROP_DEFAULT_DATE_FORMAT), {silent: true});
            }
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumericNotPeriod(ev);
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    recalculateDate() {
        let propVal = this.columnModel.get('dateValueType');
        switch (propVal) {
            case 'Empty':
                this.resetSpecific();
                this.columnModel.set('specific', '');
                this.columnModel.set('specificDisplay', '');
                break;
            case 'Now':
                this.resetSpecific();
                var date = new Date();
                this.columnModel.set('dateValueObj', date);
                this.columnModel.set('specific', dateUtil.convertDateToISOString(date));
                this.columnModel.set('specificDisplay', dateUtil.getFormattedDate(date, constants.PROP_DEFAULT_DATE_FORMAT));
                break;
            case 'Specific':                
                if (!this.columnModel.get('dateValueObj')) {
                    this.columnModel.set('dateValueObj', new Date());
                }

                let specificDate = this.columnModel.get('dateValueObj'); // raw date
                this.columnModel.set('specific', dateUtil.convertDateToISOString(specificDate));
                this.columnModel.set('specificDisplay', dateUtil.getFormattedDate(specificDate, constants.PROP_DEFAULT_DATE_FORMAT));                
                $('#dateValueSpecific').attr('disabled', false);

                break;
        }
    }

    getFormattedDate(date) {
        const format = this.columnModel.attributes.format;

        const d = new Date(date);
        if (isNaN(d.getDay())) {
            return undefined;
        }

        var month = d.getMonth() + 1;
        var day = d.getDate();

        if(month <= 9) {
            month = '0' + month;
        }
        if(day <=9) {
            day = '0' + day;
        }
        if(format === 'MM/DD/YYYY') {
            return month + '/' + day + '/' +  d.getFullYear();
        }
        if(format === 'DD/MM/YYYY') {
            return day + '/' + month + '/' + d.getFullYear();
        }
        if(format === 'MM.DD.YYYY') {
            return month + '.' + day + '.' +  d.getFullYear();
        }
        if(format === 'DD.MM.YYYY') {
            return day + '.' + month  + '.' + d.getFullYear();
        }
    }

    resetSpecific(){
        $('#dateValueSpecific').attr('disabled', true);
        $('#dateValueSpecific').val('');
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal = this.columnModel.attributes[propName];

        // needs to set to the Column data within the GridData
        this.columnModel.attributes[propName] = propVal;
        this.recalculateDate();
        this.render();

        // PF-5745
        undoService.add({
            undo: () =>{
                this.columnModel.attributes[propName] = oldPropVal;
                this.recalculateDate();
                this.render();
            },
            redo:() => {
                this.columnModel.attributes[propName] = propVal;
                this.recalculateDate();
                this.render();
            }
        }, textConstants.UNDO_MOVE);

    }

    setSpecificDate(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        // needs to set to the Column data within the GridData
        this.columnModel.attributes['specific'] = dateUtil.convertDateToISOString(propVal);
        this.columnModel.attributes['specificDisplay'] = dateUtil.getFormattedDate(propVal, constants.PROP_DEFAULT_DATE_FORMAT);
        this.model.trigger('change');
    }


    setDateValue(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal = this.columnModel.attributes[propName];
        this.columnModel.attributes[propName] = propVal;

        this.columnModel.set( 'showEmpty', 'false', {silent:true} );
        this.columnModel.set( 'showNow', 'false', {silent:true} );
        this.columnModel.set( 'specific', '', {silent:true} );
        this.columnModel.set( 'specificDisplay', '', {silent:true} );

        switch (propVal) {
            case "Empty":
                this.columnModel.set( 'showEmpty', 'true', {silent:true} );
                break;
            case "Now":
                this.columnModel.set( 'showNow', 'true', {silent:true} );
                break;
        }


        this.recalculateDate();
        this.model.trigger('change');

        // PF-5745
        undoService.add({
            undo: () =>{
                this.columnModel.attributes[propName] = oldPropVal;

                this.columnModel.set( 'showEmpty', 'false', {silent:true} );
                this.columnModel.set( 'showNow', 'false', {silent:true} );
                this.columnModel.set( 'specific', '', {silent:true} );
                this.columnModel.set( 'specificDisplay', '', {silent:true} );
        
                switch (oldPropVal) {
                    case "Empty":
                        this.columnModel.set( 'showEmpty', 'true', {silent:true} );
                        break;
                    case "Now":
                        this.columnModel.set( 'showNow', 'true', {silent:true} );
                        break;
                    case "Specific":
                        break;
                }

                this.render();
            },
            redo:() => {
                this.columnModel.attributes[propName] = propVal;

                this.columnModel.set( 'showEmpty', 'false', {silent:true} );
                this.columnModel.set( 'showNow', 'false', {silent:true} );
                this.columnModel.set( 'specific', '', {silent:true} );
                this.columnModel.set( 'specificDisplay', '', {silent:true} );

                switch (propVal) {
                    case "Empty":
                        this.columnModel.set( 'showEmpty', 'true', {silent:true} );
                        break;
                    case "Now":
                        this.columnModel.set( 'showNow', 'true', {silent:true} );
                        break;
                    case "Specific":
                        break;
                }

                this.render();
            }
        }, textConstants.UNDO_MOVE);
    }

    _injectDatePicker() {
        const $dp = $('#dateValueSpecific');
        var renderDate=this.columnModel.get('dateValueObj') || new Date();
        var self = this;

        $dp.datepicker({
            showOn: "button",
            buttonImage: require('common/icons/calendar.png'),
            buttonImageOnly: true,
            'disabled': true,
            buttonText: "Select date",
            changeYear: true,
            changeMonth: true,
            gotoCurrent: true,
            defaultDate: renderDate,
            yearRange: this.columnModel.get('minYear')+':' +this.columnModel.get('maxYear'),
            beforeShow: function( opts ){
                setTimeout(function(){
                    $('.ui-datepicker').css('z-index', constants.Z_INDEX_CALENDAR);
                }, 0);
            },
            onSelect: function ( opts ) {
                self.columnModel.set('dateValueObj', opts);
                self.columnModel.set('specific', dateUtil.convertDateToISOString(opts));
                self.columnModel.set('specificDisplay', dateUtil.getFormattedDate(opts, constants.PROP_DEFAULT_DATE_FORMAT));
                self.render();
            }
        });

        return this;
    }

    render() {

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $(":radio[value='"+this.columnModel.attributes['dateValueType']+"']").attr('checked', true);

        if(this.columnModel.attributes['format']) {
            $('#dateFormat').find("option[value='"+this.columnModel.attributes['format']+"']").attr('selected', true);
        }

        this._injectDatePicker();

        if (this.columnModel.attributes['dateValueType'] !== 'Specific') {
            $("#dateValueSpecific").datepicker('disable');
            $('#dateValueSpecific').attr('disabled', true);
            $('#dateValueSpecific ~ img').css( 'opacity', constants.CSS_CALENDAR_DISABLE);
        }
        else {
            $("#dateValueSpecific").datepicker('enable');
            $('#dateValueSpecific').attr('disabled', false);
            $('#dateValueSpecific ~ img').css('opacity',constants.CSS_CALENDAR_ENABLE);
        }

        this.delegateEvents();
        return this;
    }

}

export default MainDateValueView;
